import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Column } from '@narvar/nth-grid';
import { MediumHeader } from '@narvar/nth-header';
import TextLink from '@narvar/nth-text-link';
import Icon from '../Icon';

const Container = styled.div`
  padding: 1rem;
  width: 100%;
`;

const Badge = styled.div`
  padding: 0.2rem;
  text-align: center;
  color: white;
  background: ${(props) => props.ctaColor};
  text-transform: uppercase;
  border-radius: 4px;
  width: 3rem;
  margin: 0 auto;
`;

const StyledButton = styled.button`
  border-radius: 4px;
  font-size: inherit;
  font-weight: 700;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: inset 0 0 0 ${(props) => (props.selected ? `2px ${props.ctaColor}` : '1px #cccccc')};
  padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  width: 100%;
  text-align: left;
  &:hover {
    ${(props) => (props.selected ? '' : `box-shadow: inset 0 0 0 1px ${props.ctaColor}`)};
  }
  @media (max-width: 660px) {
    display: block;
    text-align: center;
    padding-bottom: 1.5rem;
  }
`;

const mapStateToProps = ({
  language,
  page: { pickupsEnableCTA },
  retailerSettings: { branding: { brand_call_to_action: ctaColor } = {} } = {},
  addons: { addons, addonsDisplay },
}) => ({
  language,
  ctaColor,
  pickupsEnableCTA,
  addons,
  addonsDisplay,
});

const PickupCTA = ({ ctaColor, language, pickupsEnableCTA, addons }) => {
  if (!pickupsEnableCTA || !addons.length) {
    return null;
  }

  const [{ call_to_action_url: url }] = addons;

  if (!url) {
    return null;
  }

  return (
    <Container>
      <StyledButton ctaColor={ctaColor} onClick={() => window.open(url, '_blank')}>
        <Row>
          <Column xs-columns={12} sm-columns={2}>
            <Row>
              <Badge ctaColor={ctaColor}>{language['returns.pickups_page.pickup_cta.badge']}</Badge>
            </Row>
            <Row>
              <Icon.Truck s={{ width: '6rem' }} noFill />
            </Row>
          </Column>
          <Column xs-columns={12} sm-columns={10}>
            <MediumHeader
              s={{
                margin: '0.75rem 0 0.5rem',
                fontFamily: 'inherit',
              }}
            >
              {language['returns.pickups_page.pickup_cta.title']}
            </MediumHeader>
            <p style={{ fontWeight: 400, fontFamily: 'inherit' }}>
              {language['returns.pickups_page.pickup_cta.description']}
            </p>
            <TextLink
              s={{
                color: ctaColor,
                hoverColor: ctaColor,
                fontWeight: 'bold',
                fontFamily: 'inherit',
              }}
            >
              {language['returns.pickups_page.pickup_cta.learn_more']}
            </TextLink>
          </Column>
        </Row>
      </StyledButton>
    </Container>
  );
};

PickupCTA.defaultProps = {
  ctaColor: '#000000',
  pickupsEnableCTA: false,
};

PickupCTA.propTypes = {
  language: PropTypes.object.isRequired,
  addons: PropTypes.array.isRequired,
  ctaColor: PropTypes.string,
  pickupsEnableCTA: PropTypes.bool,
};

export default connect(mapStateToProps)(PickupCTA);
